import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {} = {
  myFavorites: null,
  error: false,
  loading: false,
};
const fetchMyFavoritesSuccess = (state = initialState, action) => {

  const updatedState = {
    myFavorites: action.myFavorites,
    error: false,
    loading: false,
  };
  return updateObject(state, updatedState);
};
const myFavorites = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MY_FAVORITES_START: {
      return {
        ...state,
        error: false,
        loading: true,
      };
    }
    case actionTypes.FETCH_MY_FAVORITES_SUCCESS: {
      // return {
      //   ...state,
      //   myFavorites: action.myFavorites,
      //   error: false,
      //   loading: false,
      // };
      return fetchMyFavoritesSuccess(state, action);
    }
    case actionTypes.FETCH_MY_FAVORITES_FAILED: {
      return {
        ...state,
        error: true,
        loading: false,
        myFavorites: null,
      };
    }
    default:
      return state;
  }
};
export default myFavorites;
